import React, { useEffect, useState } from 'react'
import { Box, Button, Card, CardContent, CardHeader, CircularProgress, Typography } from '@material-ui/core'
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import api from '../api/client'

/**
 * صفحهٔ عمومیِ ثبتِ لوگو/عکس — از طریق موبایل (اسکنِ کیوآرکدِ کامپیوتر).
 * نیازی به ورود نیست؛ دسترسی با توکنِ کوتاه‌عمر کنترل می‌شود.
 */
export default function LogoUploadPublic() {
  const [token, setToken] = useState('')
  const [state, setState] = useState('idle') // idle | busy | ok | error
  const [msg, setMsg] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setToken(params.get('token') || '')
  }, [])

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file || !token) return
    setState('busy')
    setMsg('')
    try {
      const fd = new FormData()
      fd.append('logo', file)
      const res = await api.post(`users/logo-upload/${token}/`, fd)
      if (res.status === 200) {
        setState('ok')
        setMsg((res.data && res.data.detail) || 'تصویر با موفقیت ثبت شد ✓')
      } else {
        setState('error')
        setMsg((res.data && res.data.detail) || 'خطا در ثبت تصویر')
      }
    } catch (err) {
      setState('error')
      setMsg(
        (err && err.response && err.response.data && err.response.data.detail) ||
          'خطا در ثبت تصویر — ممکن است لینک منقضی شده باشد.'
      )
    } finally {
      e.target.value = ''
    }
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh', background: '#f4f6fb', padding: 16 }}
    >
      <Card elevation={5} style={{ maxWidth: 460, width: '100%' }}>
        <CardHeader title="ثبت لوگو / عکس پروفایل" />
        <CardContent style={{ textAlign: 'center' }}>
          {!token && (
            <Typography color="error">
              لینک نامعتبر است. لطفاً صفحه را در کامپیوتر دوباره باز کنید.
            </Typography>
          )}

          {token && state !== 'ok' && (
            <>
              <Typography style={{ lineHeight: 2.1, color: '#444' }}>
                با دکمهٔ زیر، دوربینِ موبایل باز می‌شود و می‌توانید از خود (یا از
                لوگوی سازمان) عکس بگیرید و بفرستید.
              </Typography>
              <Box mt={3}>
                <Button
                  component="label"
                  variant="contained"
                  color="primary"
                  disabled={state === 'busy'}
                  startIcon={state === 'busy' ? <CircularProgress size={18} /> : <PhotoCameraIcon />}
                  style={{ fontWeight: 'bold', padding: '10px 22px' }}
                >
                  {state === 'busy' ? 'در حال ارسال...' : 'گرفتن عکس با دوربین'}
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleFile}
                  />
                </Button>
              </Box>
              {state === 'error' && (
                <Typography variant="body2" style={{ marginTop: 16, color: '#c62828' }}>
                  {msg}
                </Typography>
              )}
            </>
          )}

          {state === 'ok' && (
            <Box style={{ padding: '18px 0' }}>
              <Typography variant="h6" style={{ color: '#2e7d32', fontWeight: 700 }}>
                {msg}
              </Typography>
              <Typography variant="body2" style={{ marginTop: 10, color: '#666' }}>
                می‌توانید این صفحه را ببندید و به کامپیوتر برگردید.
              </Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}
